import { transformUrlProxy, SLD } from '@patsnap-utils/biz';
export const DEPLOY_ENV = process.env.VUE_APP_DEPLOY_ENV;
export const CLIENT_ID = process.env.VUE_APP_PASSPORT_CLIENT_ID;
export const CLIENT_NAME = process.env.VUE_APP_PASSPORT_CLIENT_NAME;
export const NODE_ENV = process.env.NODE_ENV;
export const PACKAGE_VERSION = process.env.VUE_APP_PACKAGE_VERSION;
export const PASSPORT_URI = transformUrlProxy(SLD.PASSPORT, process.env.VUE_APP_PASSPORT_URI);
export const BO_ADMIN_URI = transformUrlProxy(SLD.ADMIN, process.env.VUE_APP_BO_ADMIN_URI);
export const WORKSPACE_URI = transformUrlProxy(SLD.WORKSPACE, process.env.VUE_APP_WORKSPACE_URI);
export const CHEMICAL_URI = transformUrlProxy(SLD.CHEMICAL, process.env.VUE_APP_CHEMICAL_URI);
export const BIO_URI = transformUrlProxy(SLD.BIO, process.env.VUE_APP_BIO_URI);
export const DISCOVERY_URI = transformUrlProxy(SLD.DISCOVERY, process.env.VUE_APP_DISCOVERY_URI);
export const ANALYTICS_URI = transformUrlProxy(SLD.ANALYTICS, process.env.VUE_APP_ANALYTICS_URI);
export const HOME_URI = transformUrlProxy(SLD.HOME, process.env.VUE_APP_HOME_URI);
export const ACCOUNT_URI = transformUrlProxy(SLD.ACCOUNT, process.env.VUE_APP_ACCOUNT_URI);
export const OPENAPI_URI = transformUrlProxy(SLD.OPEN, process.env.VUE_APP_OPENAPI_URI);
export const EUREKA_URI = transformUrlProxy(SLD.EUREKA, process.env.VUE_APP_EUREKA_URI);
export const SYNAPSE_URI = transformUrlProxy(SLD.SYNAPSE, process.env.VUE_APP_SYNAPSE_URI);
export const INSIGHTS_URI = transformUrlProxy(SLD.INSIGHTS, process.env.VUE_APP_INSIGHTS_URI);
export const DASHBOARD_URI = transformUrlProxy(SLD.DASHBOARD, process.env.VUE_APP_DASHBOARD_URI);
export const WORKSPACE_SERVICE_URI = process.env.VUE_APP_WORKSPACE_SERVICE_URI;
export const MARKETPLACE_SERVICE_URI = process.env.VUE_APP_MARKETPLACE_SERVICE_URI;
export const ACCOUNT_SERVICE_URI = process.env.VUE_APP_ACCOUNT_SERVICE_URI;
export const CORE_BASIC_SERVICE_URI = process.env.VUE_APP_CORE_BASIC_SERVICE_URI;
export const CORE_SEARCH_SERVICE_URI = process.env.VUE_APP_CORE_SEARCH_SERVICE_URI;
export const HOME_SERVICE_URI = process.env.VUE_APP_HOME_SERVICE_URI;
export const LAB_SERVICE_URI = process.env.VUE_APP_LAB_SERVICE_URI;
export const BIO_SERVICE_URI = process.env.VUE_APP_BIO_SERVICE_URI;
export const WSPLUGIN_ENTRY_BIO = process.env.VUE_APP_WSPLUGIN_ENTRY_BIO;
export const WSPLUGIN_ENTRY_SYNAPSE = process.env.VUE_APP_WSPLUGIN_ENTRY_SYNAPSE;
export const OFFICIAL_URL = process.env.VUE_APP_OFFICIAL_URL;
export const CHEMICAL_SERVICE_URI = process.env.VUE_APP_CHEMICAL_SERVICE_URI;
export const EUREKA_SERVICE_URI = process.env.VUE_APP_EUREKA_SERVICE_URI;
export const workspaceApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/workspace/web`;
export const workspaceForBioApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/life-science-search-web`;
export const analysisApiUrlPrefix = `${ANALYTICS_URI}/analysis-api/analysis-matrix`;
export const marketplaceApiUrlPrefix = `${MARKETPLACE_SERVICE_URI}/marketplace-api`;
export const coreAnalysisApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/analysis-api`;
export const coreBasicApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-basic-api`;
export const coreSearchApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/core-search-api/search`;
export const emailAlertApiUrlPrefix = `${HOME_SERVICE_URI}/email-alert-api`;
export const labServiceApiUrlPrefix = `${LAB_SERVICE_URI}/lab-service`;
export const lifeScienceApiUrlPrefix = `${BIO_SERVICE_URI || BIO_URI}/life-science-search-web`;
export const passportApiUrlPrefix = `${PASSPORT_URI}`;
export const chemicalAipUrlPrefix = `${CHEMICAL_SERVICE_URI}`;
export const STATIC_COMMON_URL = process.env.VUE_APP_STATIC_COMMON_URL;
export const LAB_PATENT_COLOR_ANCHOR = process.env.VUE_APP_LAB_PATENT_COLOR_ANCHOR;
export const LAB_PATENT_WORD_CLOUD_ANCHOR = process.env.VUE_APP_LAB_PATENT_WORD_CLOUD_ANCHOR;
export const LAB_WORKSPACE_LITE_TABLE_ANCHOR = process.env.VUE_APP_LAB_WORKSPACE_LITE_TABLE_ANCHOR;
export const LAB_DEEP_VIEW_ANCHOR = process.env.VUE_APP_LAB_DEEP_VIEW_ANCHOR;
export const LAB_HI_RES_IMAGE_ANCHOR = process.env.VUE_APP_LAB_HI_RES_IMAGE_ANCHOR;
